// components/Header/Header.js
import NavigationBar from "../NavigationBar/NavigationBar";

const Header = () => {
    return <NavigationBar />;
};

export default Header;